<template>
  <div>
    <order-details-top v-if="transaction"
                       :transaction="transaction"
                       :visibility="visibilityOptions"
                       :show-button="false"
    />
    <main>
      <error-data v-if="isErrorDataSet"/>
      <div v-else>
        <result-processing v-if="isPending()"/>
        <div v-else>
          <div class="container">
            <div class="columns confirmation">
              <section class="sidebar-column" id="payment-section-summary" aria-labelledby="section-summary-heading" v-if="transaction">
                <order-details-side :transaction="transaction"
                                    :visibility="visibilityOptions"
                                    :show-button="false"/>
              </section>
              <section class="main-column">
                <div class="content confirmation-wrapper">
                  <result-positive v-if="isConfirmed()"/>
                  <result-negative v-if="isFailure()"/>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ErrorData from '@/base/components/Error/Data'
import OrderDetailsSide from '@/base/components/OrderDetails/Side'
import OrderDetailsTop from '@/base/components/OrderDetails/Top'
import { ToolsClass } from '@/base/class/tools.class'
import viewMixin from '@/base/mixins/view.mixin'
import { pageTitle } from '@/base/const/routing.const'
import { RESULT_STATE } from '@/base/const/result.const'
import ResultProcessing from '@/base/components/Result/Processing.vue'
import ResultPositive from '@/base/components/Result/Templates/Positive.vue'
import ResultNegative from '@/base/components/Result/Templates/Negative.vue'

export default {
  name: 'Result',
  metaInfo () {
    return {
      title: pageTitle().base,
      titleTemplate: '%s | ' + pageTitle().result
    }
  },
  mixins: [viewMixin],
  components: {
    ResultNegative,
    ResultPositive,
    ResultProcessing,
    OrderDetailsSide,
    OrderDetailsTop,
    ErrorData
  },
  props: {
    apiToken: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.result.loading,
      state: state => state.result.data ? state.result.data.resultStatus : null,
      isResultDataSet: state => state.result.data && state.result.data.transaction,
      transaction: state => state.result.data?.transaction,
      visibilityOptions: state => state.result.data?.visibilityOptions,
      paywayId: state => state.result.data?.transaction.paywayId
    }),
    ...mapGetters({
      isErrorDataSet: 'isErrorDataSet'
    }),
    canShowMobileOrderDetails: function () {
      return !this.isLoading && this.isResultDataSet
    }
  },
  methods: {
    ...mapMutations([
      'SET_ERROR_DATA',
      'SET_RESULT_LOADING'
    ]),
    ...mapActions([
      'getResultTrx'
    ]),
    isConfirmed () {
      return this.state === RESULT_STATE.confirmed
    },
    isPending () {
      return this.state === RESULT_STATE.pending
    },
    isFailure () {
      return this.state === RESULT_STATE.failure
    },
    getResultData () {
      const data = {
        apiToken: this.apiToken
      }
      this.getResultTrx(data)
        .then(() => {
          if (this.isPending()) {
            setTimeout(() => {
              this.getResultData()
            }, 2000)
          }
        })
        .catch(error => {
          this.SET_ERROR_DATA({
            errorCode: error.body.errorCode,
            errorMessage: error.body.errorMessage,
            errorUrl: error.body.errorUrl
          })
        })
    }
  },
  created () {
    this.SET_RESULT_LOADING(true)
  },
  mounted () {
    ToolsClass.scrollToElementTop(document.querySelector('header'))
    this.getResultData()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setWindowSize)
  }
}
</script>
